import React from 'react';

const IndicatorsContext = React.createContext({

    affinitiesQuantity: null,
    advisersData: null,
    monthlyEmissionsQuantity: null,
    totalEmissionsQuantity: null,
    totalAverageQuota: null,
    monthlyAverageQuota: null,
    monthlyPremium: null,

    totalEmissionsByAffinity: null,
    totalQuotationsByAffinity: null,
    totalQuotationsQuantity: null,

    isReady: false

});

export default IndicatorsContext;